import { useEffect, useState } from "preact/hooks";
import { route } from "preact-router";
import { STRINGS } from "../constants/strings";
import { toErrorPath } from "../routes";
import type { ErrorType } from "../types";

export function useResourceLoad<T extends { status: string }>(
  token: string | undefined,
  fetcher: (token: string) => Promise<T>
): { data: Extract<T, { status: "ok" }> | null; loadError: string | null } {
  const [data, setData] = useState<Extract<T, { status: "ok" }> | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      route(toErrorPath("invalid"), true);
      return;
    }
    let cancelled = false;
    fetcher(token)
      .then((res) => {
        if (cancelled) return;
        if (res.status === "ok") {
          setData(res as Extract<T, { status: "ok" }>);
        } else if (res.status === "rate_limited") {
          setLoadError(STRINGS.resendRateLimit);
        } else {
          route(toErrorPath(res.status as ErrorType), true);
        }
      })
      .catch(() => {
        if (!cancelled) route(toErrorPath("invalid"), true);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return { data, loadError };
}
